import React from 'react';
import 'twin.macro';

interface Props {
  children: React.ReactNode;
  style?: object;
  className?: string;
}

export function Navbar(props: Props) {
  const { children, style, className = '' } = props;
  return (
    <div
      aria-label="header"
      style={style}
      tw="sticky bg-white"
      className={className}
    >
      <div tw="p-2 md:px-6 md:py-3">
        <div tw="flex items-center justify-between h-10">{children}</div>
      </div>
    </div>
  );
}
